import { jsx as _jsx } from "react/jsx-runtime";
import { clsx } from 'clsx';
/**
 * Message component for auth forms
 * Used for success messages, error messages, info, etc.
 */
export const AuthMessage = ({ variant = 'info', className, children, }) => {
    return (_jsx("div", { className: clsx('auth-message', `auth-message--${variant}`, className), role: variant === 'error' ? 'alert' : 'status', children: children }));
};
AuthMessage.displayName = 'AuthMessage';
//# sourceMappingURL=AuthMessage.js.map